import React, { Component } from "react";
import { StyleSheet } from 'aphrodite';
import Card from "../../Components/Card/bigCard";
import { Link } from 'react-router-dom'

class Devolution extends Component {
    render() {
        return <div className="content pt-6">
            <div className="container">
                <Card>
                    <div className="d-inline back">
                        <Link to='/' className="back-btn"><i className="fa fa-caret-left"></i> Volver a la Plataforma</Link>
                    </div>
                    <div style={{ height: '500px', paddingLeft: '4rem', paddingRight: '4rem' }}>
                        <center>
                            <h4 className="pt-4 pb-4">Políticas de Devolución</h4>
                        </center>
                        <p align="justify">
                            Cada socio es responsable de la compra que realice a través de la plataforma. El Santo Domingo Country Club no se hace responsable
                            si el cliente no asiste al evento adquirido y tampoco se podrá realizar un cambio de asiento a menos que así lo requiera la Institución.
                        </p>
                    </div>
                </Card>
            </div>
        </div>;
    }
}
const styles = StyleSheet.create({
    titleStyle: {
        fontSize: '1.4rem',
        fontWeight: '1'
    }
})
export default Devolution;



// WEBPACK FOOTER //
// ./src/Pages/Politics/Devolution.js